export enum OpenTaskType {
  openTask = 'openTask',
}

export enum UserFlowItemType {
  questionnaire = 'questionnaire',
  document = 'document',
  task = 'task',
}
